var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jumbotron"},[_c('h2',[_vm._v("Page not found")]),_c('p',[_vm._v("This page was deleted, moved or never existed.")]),_c('p',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"#","role":"button"}},[_vm._v("Go to main page")])])])
}]

export { render, staticRenderFns }